var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-main-button',_vm._g({staticClass:"vote-button__wrapper",attrs:{"font-small":_vm.fontSmall,"border-radius-small":_vm.borderRadiusSmall,"to":_vm.voteFormTo},on:{"click":_vm.handleClick}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }